import { pad, zeroHash } from 'viem';

export const encodeNativeWithdrawalSwapData = (
  routerAddress: `0x${string}`,
  routerSwapData: readonly `0x${string}`[]
): readonly `0x${string}`[] => {
  const swapDataWithoutIntermediateMinimum = routerSwapData.length
    ? [zeroHash, ...routerSwapData.slice(1)]
    : [];

  return [
    pad(routerAddress, { size: 32 }),
    ...swapDataWithoutIntermediateMinimum,
  ];
};
